import { Fragment } from 'react';
import PropTypes from 'prop-types';

const RESIZER_DIRECTIONS = ["top-left", "top-right", "bottom-left", "bottom-right"]

const Resizer = ({ classNamePrefix, onResizeStart }) => (
  <Fragment>
    {RESIZER_DIRECTIONS.map(direction => (
      <div
          className={`${classNamePrefix} ${classNamePrefix}--${direction}`}
          key={direction}
          onPointerDown={event => onResizeStart(direction, event)}
      />
    ))}
  </Fragment>
)

Resizer.propTypes = {
  classNamePrefix: PropTypes.string.isRequired,
  onResizeStart: PropTypes.func.isRequired
}

export default Resizer
